<p-dialog header="Workbench" [(visible)]="visible" [modal]="true" [style]="{width: '700px'}" [closable]="true"
	(onHide)="close()">
	<div *ngIf="!mergeList || mergeList.length === 0" class="p-text-center p-m-3">
		{{translateServ.dictionary['WORKBENCH_EMPTY_MSG']}}
	</div>
	<p-table *ngIf="mergeList && mergeList.length > 0" [value]="mergeList" class="w-full mb-3" [responsiveLayout]="'scroll'">
	   <ng-template pTemplate="header">
		   <tr>
			   <th>{{translateServ.dictionary['JMT_COL_ID']}}</th>
			   <th>{{translateServ.dictionary['SUPPLIER']}}</th>
			   <th>{{translateServ.dictionary['JMT_COL_BUSINESS_ID']}}</th>
			   <th>Group</th>
			   <th>Status</th>
			   <th>{{ translateServ.dictionary['STEP_TAB_TIT_ACT']}}</th>
		   </tr>
	   </ng-template>
	   <ng-template pTemplate="body" let-file let-rowIndex="rowIndex">
		   <tr>
			   <td>{{ file.FileRecID }}</td>
			   <td>{{ file.CustomerName }}</td>
			   <td>{{ file.Business_ID }}</td>
			   <td>
				   <p-inputNumber
					   [(ngModel)]="file.Group"
					   [min]="1"
					   [showButtons]="true"
					   [inputStyle]="{width: '80px', height: '2.1em', fontSize: '1em', padding: '2px 0', textAlign: 'center'}"
					   [style]="{verticalAlign: 'middle'}"
					   (ngModelChange)="file.Group = file.Group < 1 ? 1 : file.Group; onGroupChange(file, rowIndex)"
					   [attr.aria-label]="'Group number'"
				   ></p-inputNumber>
			   </td>
			   <td>
				   <!-- Status column: show spinner or MergeRecID for the group -->
				   <ng-container *ngIf="file.Group && groupLoading[file.Group]">
					   <i class="pi pi-spin pi-spinner" style="font-size:1.2em;vertical-align:middle;"></i>
					   <span style="margin-left:0.5em;">{{translateServ.dictionary['MERGING']}}...</span>
				   </ng-container>
				   <ng-container *ngIf="file.Group && !groupLoading[file.Group] && groupResult[file.Group]">
					   <span style="color:#059669;">{{translateServ.dictionary['NEW_ID']}}: {{ groupResult[file.Group] }}</span>
				   </ng-container>
			   </td>
			   <td>
				   <p-button label="{{translateServ.dictionary['DELETE']}}" icon="pi pi-trash" styleClass="p-button-text p-button-sm"
					   (click)="$event.stopPropagation(); remove.emit(file.FileRecID)"></p-button>
			   </td>
		   </tr>
	   </ng-template>
	</p-table>
	<div class="flex justify-content-end">
		<p-button label="Merge" icon="pi pi-box" styleClass="p-button-outlined p-button-sm" (click)="mergeFilesByGroup()" [disabled]="!mergeList || mergeList.length === 0 || merging"></p-button>
	</div>
</p-dialog>